export default () =>({
   loading:false,
   error:false,
   faq:{},
});